module.exports = __webpack_public_path__ + "img/iron-man.6568fd58.png";